import { getRequestContextValuesFromDraft } from "./getRequestContextValuesFromDraft";
import { getDraftPayloadValuesFromRequestContext } from "./getDraftPayloadValuesFromRequestContext";
import { getAdditionalFormKeyFromApplication } from "./getAdditionalFormKeyFromApplication";

const Utils = {
  getRequestContextValuesFromDraft,
  getDraftPayloadValuesFromRequestContext,
  getAdditionalFormKeyFromApplication,
};

export {
  Utils,
  getRequestContextValuesFromDraft,
  getDraftPayloadValuesFromRequestContext,
  getAdditionalFormKeyFromApplication,
};

export default Utils;
